import React from 'react';
import { Header } from '../components/Header';
import { ComparisonTable } from '../components/ComparisonTable';
import { BenefitSection } from '../components/BenefitSection';
import { CTASection } from '../components/CTASection';
import { Testimonials } from '../components/Testimonials';
import { Button } from '../components/ui/Button';
import { motion } from 'framer-motion';
const benefits = [{
  title: 'Treat Time. Reinvented.',
  headline: 'NEW innovative spill-proof formula designed to turn chaos into calm',
  description: "Snugges created the perfect liquid lick bowl that works with your dog's instincts instead of against them. The combination of a floating slow-release disc, anti-slip base, and these key design features are essential to keeping floors clean, dogs calm, and pet parents stress-free.*",
  imageBadge: '☕ The Perfect Spill-Proof Bowl',
  ctaText: 'Experience Clean Treat Time',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/oa4ZmFGDg3fUEcweUNGcfo/Listicle_First.jpg'
}, {
  title: 'No More Mess',
  headline: 'Keeps liquid treats contained so you can say goodbye to sticky floors forever',
  description: 'The floating disc mechanism naturally prevents splashes and spills, helping you maintain a cleaner home. This unique combination keeps liquid treats exactly where they belong—in the bowl, not on your carpet. No more yogurt explosions. No more broth puddles.',
  imageBadge: '🔒 Mess-Free Guarantee',
  ctaText: 'Experience Clean Treat Time',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/uWyDqnvFDxi3ZmCcUUeDhj/471ce5a3-1502-4a4e-9143-01ab61e26e1d.png'
}, {
  title: 'Calming Lick Sessions',
  headline: "It's your dog's new zen ritual thanks to the slow-release design",
  description: "Support your dog's mental wellness with this bowl crafted for calm. The controlled licking pace and floating disc mechanism promote slower intake and trigger natural endorphin release, creating a soothing, meditative experience. It's enrichment that actually works.*",
  imageBadge: '🌿 Zen Mode Activated',
  ctaText: 'Discover Calm Treat Time',
  imageUrl: 'https://images.unsplash.com/photo-1530281700549-e82e7bf110d6?auto=format&fit=crop&w=800&q=80'
}, {
  title: 'No More Gulping',
  headline: 'It slows down frantic slurping, protecting your dog from choking and overstimulation',
  description: 'While regular bowls let dogs gulp dangerously fast, Snugges uses a patented floating slow-release system that physically controls the flow. Your dog gets all the flavor and satisfaction without the coughing fits, hyperactivity, or upset stomach that comes from rapid intake.',
  imageBadge: '🚫 Slow & Safe Feeding',
  ctaText: 'Keep Your Pup Safe & Calm',
  imageUrl: 'https://images.unsplash.com/photo-1583337130417-3346a1be7dee?auto=format&fit=crop&w=800&q=80'
}, {
  title: 'Save Big On Cleanup',
  headline: 'It eliminates hours of scrubbing floors, carpets, and lick mats every week',
  description: 'Did you know the average dog parent spends 2-3 hours per week cleaning up after messy treat sessions? Skip the floor scrubbing, carpet shampooing, and endless dishwashing cycles—and get back those precious hours with Snugges today!',
  imageBadge: '🤑 Save Hours Weekly',
  ctaText: 'Reclaim Your Time Today',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/adZQaaUp3CUW4H6wyhe5xX/Bowl_2.webp'
}, {
  title: 'Effortless Enrichment',
  headline: 'It creates the perfect liquid treat experience in just seconds—no freezing required',
  description: 'Make enriching treat time right from your kitchen with just one pour of yogurt, broth, goat milk, or kefir. Works fresh OR frozen. No complicated prep, no messy freezer transfers—we suggest keeping a few prepared in the fridge for instant calm!',
  imageBadge: '🎯 Ready In Seconds',
  ctaText: 'Make Enrichment Easy',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/e9RpDtAtFKBEFusAKZbfKW/Bowl_1.webp'
}, {
  title: 'Longer Lasting Joy',
  headline: 'You can transform a 30-second gulp into 10-20 minutes of calm, focused licking',
  description: 'The floating disc gives gradual access to treats, while the engaging design ensures sustained licking activity. This extended engagement helps maintain mental stimulation without the crash associated with fast treat consumption—just sustained satisfaction.',
  imageBadge: '⚡ 10-20 Min Sessions',
  ctaText: 'Extend Treat Time Joy',
  imageUrl: 'https://images.unsplash.com/photo-1544568100-847a948585b9?auto=format&fit=crop&w=800&q=80'
}, {
  title: 'Vet-Recommended Relief',
  headline: 'It helps dogs with anxiety, post-surgery recovery, and picky drinking habits stay hydrated and calm',
  description: 'Veterinarians recommend slow licking for anxiety relief and post-operative care. Snugges helps senior dogs, puppies with sensitive stomachs, and recovering pets consume liquid nutrition safely without stress or mess—making it the perfect tool for gentle care when they need it most.*',
  imageBadge: '💪 Vet Approved Solution',
  ctaText: "Support Your Dog's Health",
  imageUrl: 'https://images.unsplash.com/photo-1552053831-71594a27632d?auto=format&fit=crop&w=800&q=80'
}, {
  title: 'Risk-Free Choice',
  headline: 'Join 10,000+ happy pet parents and try it with our 30-Day Money-Back Guarantee',
  description: "We know changing your treat routine feels scary when you've dealt with so much mess and stress before. We're so confident Snugges will transform treat time that if for any reason you're not completely satisfied—simply let us know and we'll happily refund your purchase!",
  imageBadge: '👍 30-Day Guarantee',
  ctaText: 'Start Your Risk-Free Trial',
  imageUrl: 'https://images.unsplash.com/photo-1534361960057-19889db9621e?auto=format&fit=crop&w=800&q=80'
}, {
  title: 'Built For Real Dogs',
  headline: 'Loved by anxious dogs, picky drinkers, power chewers, and spoiled pups everywhere',
  description: "In just months, Snugges has helped 10,000+ dog parents turn messy, stressful treat time into calming bonding moments. Join a community of pet parents who've finally found the solution that actually works for liquid treats—no compromises.",
  imageBadge: '🌍 10,000+ Happy Dogs',
  ctaText: 'Join The Snugges Community',
  imageUrl: 'https://images.unsplash.com/photo-1561037404-61cd46aa615b?auto=format&fit=crop&w=800&q=80'
}];
export function SnuggesListicle() {
  // Get today's date formatted as "Month Day, Year"
  const today = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-112">
      <Header data-id="element-113" />

      <main className="mx-auto max-w-4xl px-4 py-8 md:py-12" data-id="element-114">
        {/* Hero Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-center mb-12" data-id="element-115">
          <h1 className="text-3xl md:text-5xl font-extrabold tracking-tight leading-tight mb-6" data-id="element-116">
            11 Reasons Why This Liquid Lick Bowl is the{' '}
            <span className="text-[#9AC1F0] underline decoration-4 decoration-[#FFD700]" data-id="element-117">
              #1 Trending Solution
            </span>{' '}
            for Messy Treat Time This Season
          </h1>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-sm text-gray-500 mb-8" data-id="element-118">
            <div className="flex items-center gap-2" data-id="element-119">
              <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=100&q=80" alt="Author" className="w-8 h-8 rounded-full" data-id="element-120" />
              <span data-id="element-121">
                By <strong data-id="element-122">Sarah Jenkins</strong>
              </span>
            </div>
            <span className="hidden md:inline" data-id="element-123">•</span>
            <span data-id="element-124">Last Updated: {today}</span>
          </div>

          <div className="bg-red-50 border-l-4 border-red-500 p-4 text-left max-w-2xl mx-auto rounded-r-lg" data-id="element-125">
            <p className="font-bold text-red-800 italic" data-id="element-126">
              "Read this BEFORE your next messy treat session!"
            </p>
          </div>
        </motion.div>

        <ComparisonTable data-id="element-127" />

        <div className="my-12 p-6 bg-yellow-50 rounded-xl border border-yellow-200" data-id="element-128">
          <p className="font-bold text-lg mb-2" data-id="element-129">
            TLDR: Using Snugges Liquid Lick Bowl has 11+ life-changing benefits
            for both you and your pup 👇
          </p>
        </div>

        {/* Benefits List */}
        <div className="space-y-4" data-id="element-130">
          {benefits.map((benefit, index) => <div key={index} data-id="element-131">
              <BenefitSection number={index + 1} {...benefit}
          // Alternate layout for visual interest
          isReversed={index % 2 !== 0} data-id="element-132" />
            </div>)}

          {/* Final Benefit #11 - Special Layout */}
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="py-16 text-center bg-[#9AC1F0]/5 rounded-3xl my-12 px-6" data-id="element-133">
            <div className="max-w-2xl mx-auto" data-id="element-134">
              <h2 className="text-3xl font-bold mb-6" data-id="element-135">
                Reaching #11 means one thing: you're truly serious about ending
                messy treat time forever.
              </h2>
              <p className="text-xl text-gray-600 mb-8" data-id="element-136">
                ✨ We don't hand these out every day... consider this an
                exclusive Snugges hookup, just for you.
              </p>

              <div className="relative rounded-xl overflow-hidden shadow-2xl mb-8 transform rotate-1 hover:rotate-0 transition-transform duration-500" data-id="element-137">
                <img src="https://images.unsplash.com/photo-1576201836106-db1758fd1c97?auto=format&fit=crop&w=1200&q=80" alt="Snugges Product" className="w-full h-auto" data-id="element-138" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end justify-center pb-8" data-id="element-139">
                  <span className="text-white font-bold text-xl" data-id="element-140">
                    The Ultimate Treat Time Solution
                  </span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        <Testimonials data-id="element-141" />

        <CTASection variant="final" data-id="element-142" />

        <footer className="mt-20 pt-8 border-t border-gray-200 text-center text-sm text-gray-500 pb-8" data-id="element-143">
          <p className="mb-4" data-id="element-144">
            *Special sale discount is valid only on first-time purchases.
            Snugges subscription renews every 30 days at discounted rate. Max
            one offer per customer.
          </p>
          <div className="flex justify-center gap-6 mb-4" data-id="element-145">
            <a href="#" className="hover:underline" data-id="element-146">
              Terms of Service
            </a>
            <a href="#" className="hover:underline" data-id="element-147">
              Privacy Policy
            </a>
            <a href="#" className="hover:underline" data-id="element-148">
              Refund Policy
            </a>
          </div>
          <p data-id="element-149">© 2025 Snugges. All rights reserved.</p>
        </footer>
      </main>
    </div>;
}